import { Grid } from '@mui/material'
import React from 'react'
// import background_login from "assets/banner_image.webp"
import background_login from "assets/banner_image_backrr_startups.png"

const CustomBackgroundComponent = ({ bgImage, xs = 12, sm = 12, md = 5.4, lg = 5.4, xl = 5.4 }) => {
    return (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} sx={{display: {xs : "none", md: "flex"}, borderRadius: '16px', overflow:"hidden",maxHeight: "94dvh", height:'100%'}}>
        {/* // , backgroundImage: `url(${background_login})` , backgroundSize: "fit", backgroundPosition: "center", backgroundRepeat: 'no-repeat',maxHeight: "94dvh"}}> */}
            <img src={background_login} alt='login_image' loading='lazy' style={{ objectPosition: 'center', objectFit: "contain", width: "100%", height: "100%" }} />
        </Grid>
    )
}

export default CustomBackgroundComponent